export default "__VITE_ASSET__2DNuu1fk__ 400w, __VITE_ASSET__CQwByKaa__ 800w, __VITE_ASSET__DEBLScbd__ 1280w";